import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { from, Observable } from 'rxjs';
import { get, post, put } from 'aws-amplify/api'

@Injectable({
  providedIn: 'root'
})
export class SedEventsService {

    constructor(private apiService: ApiService) { }

    GetSedEvents(isActive: boolean, thresholdDate: Date): Observable<any[]> {
      const options = {
        queryParams: {
          isActive: isActive.toString(),
          thresholdDate: thresholdDate.toISOString()
        }
      }
      return this.apiService.get(`/Event/GetbyStatusDate`, options)
    }

    // GetByStatus(isActive: boolean): Observable<any[]> {
    //   const options = {
    //     queryParams: {
    //       isActive: isActive,
    //     }
    //   }
    //   return this.apiService.get(`/SedEvents/GetByStatus`, options)
    // }
    
}
